import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useHeaderLinks } from 'providers/AreasProvider';
import ErrorModal from 'components/notifications/ErrorModal';
import NotificationContainer from 'components/notifications/NotificationContainer';

function HeaderLinks() {
  const [headerLinks] = useHeaderLinks();
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [modalErrorMessage, setModalErrorMessage] = useState('');

  const toggleNotificationModal = useCallback(() => setShowNotificationModal(prevState => !prevState), []);
  const handleErrorMessageChange = useCallback(message => setModalErrorMessage(message), []);

  return (
    <>
      {headerLinks}
      {showNotificationModal && <ErrorModal onCloseModal={toggleNotificationModal} errorMessage={modalErrorMessage} />}
      <NotificationContainer
        showNotificationModal={showNotificationModal}
        toggleNotificationModal={toggleNotificationModal}
        handleErrorMessageChange={handleErrorMessageChange}
      />
    </>
  );
}

HeaderLinks.propTypes = {
  userProfile: PropTypes.object
};

export default HeaderLinks;
